import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Lock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "reveal_admin_token";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email: email.trim(), password });
      localStorage.setItem(TOKEN_KEY, data.access_token);
      navigate("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-reveal-black text-reveal-cream font-body flex items-center justify-center px-5" data-testid="admin-login-page">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-reveal-burgundy border border-reveal-rose/20 rounded-3xl px-8 py-10"
        data-testid="admin-login-form"
      >
        <div className="w-12 h-12 rounded-full bg-reveal-rose/10 flex items-center justify-center mb-6">
          <Lock className="w-5 h-5 text-reveal-rose" />
        </div>
        <h1 className="font-heading text-3xl text-reveal-cream mb-1">Admin Login</h1>
        <p className="text-sm text-reveal-cream/55 mb-8">Reveal waitlist dashboard</p>

        <label className="block text-xs uppercase tracking-widest text-reveal-rose mb-2">Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="admin-login-email-input"
          className="w-full bg-black/40 border border-reveal-rose/40 rounded-xl px-4 py-3 mb-5 text-reveal-cream outline-none focus:border-reveal-rose transition-colors"
        />
        <label className="block text-xs uppercase tracking-widest text-reveal-rose mb-2">Password</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="admin-login-password-input"
          className="w-full bg-black/40 border border-reveal-rose/40 rounded-xl px-4 py-3 mb-6 text-reveal-cream outline-none focus:border-reveal-rose transition-colors"
        />
        {error && (
          <p className="text-sm text-red-400 mb-4" data-testid="admin-login-error">{error}</p>
        )}
        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit-button"
          className="w-full bg-reveal-rose text-black font-medium py-3 rounded-full hover:bg-[#c9987b] transition-colors disabled:opacity-60"
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
